import {
  RequisitesBankFields,
  RequisitesBankRequest,
  RequisitesBankResponse,
  RequisitesBankUpdateRequest,
  RequisitesCryptoFields,
  RequisitesCryptoRequest,
  RequisitesCryptoResponse,
  RequisitesCryptoUpdateRequest,
  RequisitesVerificationRequest,
} from "./repo";
import { RequisitesType } from "./enums";

export const RequisitesBankRequestFactory = (
  payload: Partial<RequisitesBankRequest> = {}
): RequisitesBankRequest => {
  return {
    name: payload.name ?? "",
    account_number: payload.account_number ?? "",
    correspondent_account: payload.correspondent_account ?? "",
    bank_identification_code: payload.bank_identification_code ?? "",
    bank_name: payload.bank_name ?? "",
    inn: payload.inn ?? "",
    registration_reason_code: payload.registration_reason_code ?? "",
    note: payload.note ?? "",
  };
};

export const RequisitesBankUpdateRequestFactory = (
  payload: Partial<RequisitesBankRequest> = {}
): RequisitesBankUpdateRequest => {
  return {
    name: payload.name ?? "",
    account_number: payload.account_number ?? "",
    correspondent_account: payload.correspondent_account ?? "",
    bank_identification_code: payload.bank_identification_code ?? "",
    bank_name: payload.bank_name ?? "",
    inn: payload.inn ?? "",
    registration_reason_code: payload.registration_reason_code ?? "",
    note: payload.note ?? "",
  };
};

export const RequisitesBankResponseFactory = (
  payload: Partial<RequisitesBankResponse> | null = {}
): RequisitesBankResponse => {
  const data = payload ?? {};
  return {
    id: data.id ?? 0,
    user_id: data.user_id ?? 0,
    name: data.name ?? "",
    account_number: data.account_number ?? "",
    correspondent_account: data.correspondent_account ?? "",
    bank_identification_code: data.bank_identification_code ?? "",
    bank_name: data.bank_name ?? "",
    inn: data.inn ?? "",
    registration_reason_code: data.registration_reason_code ?? "",
    note: data.note ?? "",
    creatd_at: data.creatd_at ?? "",
    updated_at: data.updated_at ?? "",
  };
};

export const RequisitesBankFieldsFactory = (): RequisitesBankFields => {
  return {
    name: false,
    account_number: false,
    correspondent_account: false,
    bank_identification_code: false,
    bank_name: false,
    inn: false,
    registration_reason_code: false,
    note: true,
  };
};

export const RequisitesCryptoRequestFactory = (
  payload: Partial<RequisitesCryptoRequest> = {}
): RequisitesCryptoRequest => {
  return {
    name: payload.name ?? "",
    coin: payload.coin ?? "",
    network: payload.network ?? "",
    address: payload.address ?? "",
    note: payload.note ?? "",
  };
};

export const RequisitesCryptoUpdateRequestFactory = (
  payload: Partial<RequisitesCryptoRequest> = {}
): RequisitesCryptoUpdateRequest => {
  return {
    name: payload.name ?? "",
    coin: payload.coin ?? "",
    network: payload.network ?? "",
    address: payload.address ?? "",
    note: payload.note ?? "",
  };
};

export const RequisitesCryptoResponseFactory = (
  payload: Partial<RequisitesCryptoResponse> | null = {}
): RequisitesCryptoResponse => {
  const data = payload ?? {};
  return {
    id: data.id ?? 0,
    user_id: data.user_id ?? 0,
    name: data.name ?? "",
    coin: data.coin ?? "",
    note: data.note ?? "",
    network: data.network ?? "",
    address: data.address ?? "",
    creatd_at: data.creatd_at ?? "",
    updated_at: data.updated_at ?? "",
  };
};

export const RequisitesCryptoFieldsFactory = (): RequisitesCryptoFields => {
  return {
    name: false,
    coin: false,
    network: false,
    address: false,
    note: true,
  };
};

export const RequisitesVerificationRequestFactory = (
  payload: Partial<RequisitesVerificationRequest> = {}
): RequisitesVerificationRequest => {
  return {
    code: payload.code ?? "",
    type: payload.type ?? RequisitesType.bank,
  };
};
